// MBO Niveau 2 Studies
// Intermediate vocational studies with categories and subcategories

export const MBO_NIVEAU_2_STUDIES = {
  'Bouw & Afwerking': {
    'Ruwbouw': [
      'Metselaar',
      'Betontimmerman',
      'Betonstaalvlechter',
      'Aankomend medewerker grondoptreden',
      'Tegelzetter',
      'Waterbouwer',
      'Vakman GWW',
      'Opperman bestratingen'
    ],
    'Afwerking & Interieur': [
      'Timmerman',
      'Meubelmaker / (scheeps)interieurbouwer',
      'Interieurvakman parketvloeren',
      'Interieurvakman woningstofferen',
      'Keukenmonteur',
      'Stukadoor',
      'Glaszetter',
      'Voeger',
      'Schilder',
      'Dekvloerenlegger',
      'Natuursteenbewerker ambachtelijk',
      'Natuursteenbewerker machinaal',
      'Monteur metalen daken en gevels',
      'Dakdekker bitumen en kunststof',
      'Dakdekker riet'
    ],
    'Montage & Plaatsing': [
      'Montagemedewerker houttechniek',
      'Carrosseriebouwer'
    ]
  },
  'Techniek & Installatie': {
    'Werktuigbouw / Klimaat': [
      'Monteur koude- en klimaatsystemen',
      'Monteur gas-, water- of warmtedistributie',
      'Monteur werktuigkundige installaties',
      'Airco/warmtepompmonteur',
      'Monteur service en onderhoud installaties en systemen',
      'Verbrandingsmotortechnicus'
    ],
    'Elektrotechniek & Mechatronica': [
      'Monteur elektrotechnische installaties',
      'Monteur middenspanningsdistributie',
      'Monteur laagspanningsdistributie',
      'Monteur datadistributie',
      'Monteur mechatronica',
      'Machineoperator houttechniek'
    ],
    'Luchtvaart / Maritiem / Voertuigen': [
      'Monteur luchtvaartuigen',
      'Basis technicus voertuigen en mobiele werktuigen',
      'Autoschadehersteller',
      'Stuurman werktuigkundige zeevisvaart sw6'
    ]
  },
  'Logistiek & Transport': {
    'Transport & Rijden': [
      'Chauffeur wegvervoer',
      'Chauffeur openbaar vervoer',
      'Touringcarchauffeur',
      'Taxichauffeur'
    ],
    'Logistiek & Opslag': [
      'Logistiek medewerker',
      'Medewerker internationale havenlogistiek',
      'Medewerker havenoperaties',
      'Medewerker agrohandel en logistiek'
    ]
  },
  'Productie & Industrie': {
    'Technische productie': [
      'Industrieel lakverwerker',
      'Medewerker productietechniek',
      'Medewerker operationele techniek',
      'Medewerker voeding, technologie en techniek',
      'Medewerker versindustrie',
      'Allround medewerker afvalbeheer'
    ],
    'Voeding & Bakkerij': [
      'Kok',
      'Uitvoerend bakker',
      'Medewerker vers'
    ],
    'Drukwerk / Media / Sign': [
      'Basismedewerker printmedia',
      'Medewerker sign'
    ]
  },
  'ICT & Creatieve Media': {
    'ICT & Media': [
      'Medewerker ICT',
      'Mediamaker',
      'Medewerker fotografie',
      'Medewerker podium- en evenemententechniek'
    ]
  },
  'Dienstverlening & Zorg': {
    'Zorg & Welzijn': [
      'Helpende zorg en welzijn'
    ],
    'Beveiliging & Faciliteiten': [
      'Beveiliger 2',
      'Medewerker facilitaire dienstverlening',
      'Servicemedewerker gebouwen',
      'Gastheer/-vrouw',
      'Schoonmaker in verschillende omgevingen',
      'Meewerkend leidinggevende algemeen schoonmaakonderhoud',
      'Schoenhersteller'
    ]
  },
  'Groen, Dier & Milieu': {
    'Groen & Natuur': [
      'Medewerker hovenier',
      'Medewerker natuur, water en recreatie',
      'Medewerker groen, grond en groene infra'
    ],
    'Dier & Landbouw': [
      'Medewerker dierverzorging',
      'Medewerker teelt',
      'Medewerker veehouderij'
    ]
  },
  'Handel, Retail & Verkoop': {
    'Retail & Verkoop': [
      'Retailmedewerker',
      'Verkoopmedewerker optiek',
      'Medewerker productpresentatie',
      'Medewerker bloem, groen en styling'
    ]
  },
  'Mode & Fashion': {
    'Mode': [
      'Basismedewerker fashion'
    ]
  },
  'Scheepvaart & Binnenvaart': {
    'Maritiem': [
      'Schipper-machinist beperkt werkgebied',
      'Schipper rondvaartboot beperkt vaargebied',
      'Matroos binnenvaart',
      'Aankomend medewerker maritiem'
    ]
  }
};

export default MBO_NIVEAU_2_STUDIES;

















